"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    alert: {
        close: 'Fechar',
    },
    calendar: {
        nextMonth: 'Próximo mês',
        previousMonth: 'Mês anterior',
        nextYear: 'Próximo ano',
        previousYear: 'Ano anterior',
    },
    dateInput: {
        placeholder: 'dd/mm/aaaa',
    },
    monthInput: {
        placeholder: 'mm/aaaa',
    },
    formControl: {
        required: 'Campo obrigatório',
    },
    input: {
        clear: 'Limpar',
    },
    modal: {
        close: 'Fechar',
    },
    monthPaginator: {
        close: 'Fechar',
        show: 'Mostrar meses',
    },
    paginator: {
        of: 'de',
        previousPage: 'Página anterior',
        nextPage: 'Próxima página',
        currentPage: 'Página atual',
    },
    dateRangeField: {
        separator: 'até',
    },
    select: {
        createItem: 'Selecione um item ou digite um novo valor',
        emptyItem: 'Nenhum resultado encontrado',
        loadingItem: 'Carregando...',
        removeItem: 'Remover',
    },
    combobox: {
        showOptions: 'Mostrar opções',
        hideOptions: 'Esconder opções',
        createItem: 'Selecione um item ou digite um novo valor',
        emptyItem: 'Nenhum resultado encontrado',
        loadingItem: 'Carregando...',
        removeItem: 'Remover',
    },
    tableFooter: {
        results: {
            zero: 'resultados',
            one: 'resultado',
            other: 'resultados',
        },
    },
    aggregators: {
        count: 'Contagem',
        average: 'Média',
        maximum: 'Máximo',
        minimum: 'Mínimo',
        percentage: 'Porcentagem',
    },
    draggable: {
        search: 'Pesquisa',
        allItems: 'Todos os itens',
        all: 'todos',
    },
    droppable: {
        isOver: 'Solte o item aqui para inserir na tabela',
        isNotOver: 'Arraste os itens para inserir na tabela',
    },
    pivotTableBoard: {
        availableFields: 'Campos disponíveis',
        rows: 'Linhas',
        columns: 'Colunas',
        kindOfPresentation: 'Forma de apresentação',
        appliedFilters: 'Filtros aplicados',
        clearFilters: 'Limpar filtros',
        clearTable: 'Limpar tabela',
        clearTableTitle: 'Deseja limpar a tabela?',
        clearTableCancel: 'Cancelar',
        clearTableConfirm: 'Limpar',
        generateTable: 'Gerar tabela',
    },
};
exports.default = locale;
//# sourceMappingURL=pt-BR.js.map